import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';

/**
 * Adds a trailing slash to the path component of the address bar when Angular
 * formats a URL.
 *
 * Our front-end proxy server generates canonical URLs that include a trailing slash,
 * so we wish to keep Angular in sync with those.
 *
 * see https://github.com/angular/angular/issues/16051
 */
@Injectable()
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  serialize(tree: UrlTree): string {
    const path = super.serialize(tree);
    const pathArr = path.split('?');
    if (pathArr[0] !== '/') {
      pathArr[0] = pathArr[0] + '/'; // add trailing slash to path
    }
    return pathArr.join('?');
  }
}
